import React, { useEffect, useRef } from 'react';
import {
    message,
    Button,
    Icon,
    Modal,
    Form,
    Input,
    Radio,
    Card,
    Select,
    Table,
    Checkbox,
    Row,
    Col,
    DatePicker,
    Tag,
    Steps,
    Spin,
    Upload,
    notification,
    Popconfirm,
    List,
} from 'antd';
import { services } from '@comall-backend-builder/core';
import './index.less';
import { UploadProps } from 'antd/lib/upload';
import * as XLSX from 'xlsx';
import { isEmpty, set } from 'lodash';
import moment from 'moment';
import { errorHandle } from '../../services';
const { Step } = Steps;
const api = services.api;

const steps = [
    {
        title: '上传文件',
    },
    {
        title: '导入数据',
    },
];
interface ExcelData {
    header: string[];
    results: any[];
}
const formatDate = (numb: any) => {
    if (!numb) {
        return '';
    }
    const old = numb - 1;
    const timeRound = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
    const time = new Date(1900, 0, old, 0, 0, timeRound);
    return moment(time).format('YYYY-MM-DD');
};

// EXCEL格式
type ExcelJson = Record<string, ExcelData>;
// 导入数据
const ExportExcel = ({
    limitSize,
    ExcelHead,
    processingTime = [],
    saveData,
    url = '',
    custColumns,
    templateDown,
    handleCancel,
}) => {
    const [current, setCurrent] = React.useState(0);
    const [showSpinning, setShowSpinning] = React.useState(false);
    const missingCount = useRef(0);
    const missingValue = useRef('');
    const [column, setColumn] = React.useState([]);
    const [exportTableData, setExportTableData] = React.useState([]);
    const [failList, setFailList] = React.useState([]);

    // 处理表头数据
    const extractHeaders = (worksheet: any) => {
        const headers = [];
        const cellRange = XLSX.utils.decode_range(worksheet['!ref']);
        const headerRow = cellRange.s.r;
        for (let column = cellRange.s.c; column <= cellRange.e.c; ++column) {
            const cell = worksheet[XLSX.utils.encode_cell({ c: column, r: headerRow })];
            const header = cell && cell.t ? XLSX.utils.format_cell(cell) : `UNKNOWN${column}`;
            headers.push(header);
        }
        return headers;
    };

    // 删除当前数据
    const handleDeleteItem = (clearSeqNumber: any) => {
        setExportTableData((prevData) => {
            const newData = prevData.filter((item: any) => item.seqNumber !== clearSeqNumber);
            return newData;
        });
    };
    useEffect(() => {
        if (exportTableData.length === 0 && current === 1) handleCancel();
    }, [exportTableData]);
    // 处理table数据
    const handleGetTable = async (excelJson: ExcelJson, name: string) => {
        missingCount.current = 0; // 清空计数
        missingValue.current = ''; // 清空文案
        if (isEmpty(excelJson)) {
            return;
        }
        const columns: any = {};
        const tableData: any = {};
        let templateError = false; // 添加一个错误标识

        // 处理表头
        const processHeader = (header: string[], keyjson: string) => {
            return header.reduce((acc: any[], title: string) => {
                const key = ExcelHead[keyjson][title];
                if (key) {
                    acc.push({
                        key,
                        title,
                        dataIndex: key,
                    });
                } else if (!title?.includes('UNKNOWN')) {
                    missingCount.current = missingCount.current + 1; // 如果没有找到匹配项，就增加计数器
                    if (!!missingValue.current) {
                        missingValue.current = missingValue.current + '，' + title;
                    } else {
                        missingValue.current = title;
                    }
                }
                return acc;
            }, []);
        };

        /**
         * 获取具体的数据源
         * @param results 获取到的数据
         * @param keyjson key值
         * @param filterCodeObj 需要进行匹配的码表
         * @param codeDicAll 码表查询到的字典表
         * @returns
         */
        const processResults = async (
            results: any[],
            keyjson: string,
            filterCodeObj: any,
            codeDicAll: any
        ) => {
            return results.map((resultItem, i) => {
                const mappedResult: any = { seqNumber: i + 1 };
                // 使用正则表达式匹配数
                Object.keys(resultItem).forEach((key) => {
                    const excelHeadKey = ExcelHead[keyjson][key];
                    if (excelHeadKey) {
                        const itemValue =
                            typeof resultItem[key] === 'string'
                                ? resultItem[key].trim()
                                : resultItem[key];
                        if (processingTime?.includes(key) && typeof resultItem[key] !== 'string') {
                            mappedResult[excelHeadKey] = formatDate(resultItem[key]);
                        } else {
                            // 判断是否有映射值
                            if (
                                !isEmpty(filterCodeObj) &&
                                filterCodeObj.hasOwnProperty(excelHeadKey)
                            ) {
                                // 将字段转换成字符串
                                const codeTableValue =
                                    typeof itemValue === 'number'
                                        ? itemValue.toString()
                                        : itemValue;
                                // 使用的字段
                                const codeTableKey = filterCodeObj[excelHeadKey];
                                // 使用的码值
                                const dictsBulk = codeDicAll[codeTableKey];
                                if (!!codeTableKey && !isEmpty(dictsBulk)) {
                                    mappedResult[excelHeadKey] =
                                        dictsBulk[codeTableValue] || codeTableValue;
                                } else {
                                    mappedResult[excelHeadKey] = codeTableValue;
                                }
                            } else {
                                mappedResult[excelHeadKey] = itemValue;
                            }
                        }
                    }
                });
                return mappedResult;
            });
        };

        // 循环当前sheet
        await Promise.all(
            Object.entries<ExcelData>(excelJson).map(async ([keyjson, datajson]) => {
                const { header, results } = datajson;
                columns[keyjson] = processHeader(header, keyjson);
                // 获取到需要映射成码表的字段
                const codeTableMap = ExcelHead?.codeTableMap || {};
                // 过滤后的字段
                const filterCodeObj: any = {};
                if (columns?.sheet?.length && !isEmpty(codeTableMap)) {
                    columns.sheet.map((columnsItem: any) => {
                        if (codeTableMap.hasOwnProperty(columnsItem.dataIndex)) {
                            filterCodeObj[columnsItem.dataIndex] =
                                codeTableMap[columnsItem.dataIndex];
                        }
                    });
                }
                if (missingCount.current > 2) {
                    // 如果缺失的标题数量超过2，那么就抛出一个错误
                    notification.warning({
                        message: '模板匹配异常',
                        description: `${missingValue.current} 未匹配到，请核对后重新导入！`,
                    });
                    templateError = true;
                    return;
                }
                // 查询到的所有码表
                let codeDicAll = {};
                const resultsData = [...results];
                tableData[keyjson] = await processResults(
                    resultsData,
                    keyjson,
                    filterCodeObj,
                    codeDicAll
                );
                if (url !== '') {
                    const { resultCode, resultBody, resultMsg } = await services.api.post(
                        tableData.sheet.map((item: any) => item.unique_code),
                        {
                            apiPath: url,
                        }
                    );
                    if (resultCode === 200) {
                        if (resultBody.successNum === 0) {
                            message.error(
                                `表格中不存在正确的${
                                    templateDown === 'TAG_RULE_STYLE' ? 'SKU编号' : '华夏款号'
                                }，请检查后重新导入！`
                            );
                            templateError = true;
                            return;
                        }
                        if (resultBody.failNum > 0) {
                            setFailList(resultBody.failList || []);
                        }
                        tableData.sheet = resultBody.successList.map(
                            (item: any, index: number) => ({
                                ...item,
                                seqNumber: index + 1,
                            })
                        );
                    } else {
                        templateError = true;
                        message.error(resultMsg);
                    }
                }
            })
        );
        if (templateError) {
            return { tableData: [] };
        }
        return { tableData: tableData.sheet };
    };
    // 获取上传的数据
    const beforeUpload = (file: any) => {
        const maxFileSizeMB = limitSize ? limitSize : 10; // 文件大小
        const isFileSizeAcceptable = file.size / 1024 / 1024 < maxFileSizeMB;
        if (!isFileSizeAcceptable) {
            message.error(`文件大小不得大于${maxFileSizeMB}M!`);
            return;
        }
        // 通过FileReader对象读取文件
        const fileReader: any = new FileReader();
        fileReader.readAsBinaryString(file); //二进制
        fileReader.onload = async (event: { target: { result: any } }) => {
            try {
                const { result } = event.target;
                const workbook = XLSX.read(result, { type: 'binary' });
                const excelJson: any = {}; // 读取到文件流的格式
                workbook.SheetNames.forEach((sheetName) => {
                    const worksheet = workbook.Sheets[sheetName];
                    const header = extractHeaders(worksheet);
                    let results;
                    // 是否按照文本读取
                    const sheet2JSONOpts = {
                        raw: false,
                    };
                    results = XLSX.utils.sheet_to_json(worksheet);
                    const sheetData = {
                        header: header,
                        results: results,
                    };
                    if (Object.keys(workbook.SheetNames)?.length > 1) {
                        excelJson[sheetName] = sheetData;
                    } else {
                        excelJson.sheet = sheetData;
                    }
                });
                const hasMultipleSheets = Object.keys(excelJson)?.length > 1; // excelJson大于1
                if (hasMultipleSheets) {
                    message.warning('上传格式错误，请确认上传模板！');
                    return false;
                }
                if (isEmpty(excelJson) || isEmpty(excelJson?.sheet?.results)) {
                    message.warning('上传数据不能为空！');
                    return false;
                }
                const data = await handleGetTable(excelJson, file?.name); // 处理成table格式，也用于传递给接口
                if (data.tableData.length === 0) {
                    return false;
                }
                setColumn([
                    ...custColumns,
                    {
                        title: '操作',
                        dataIndex: 'option',
                        valueType: 'option',
                        fixed: 'right',
                        width: 70,
                        align: 'center',
                        render: (_: any, record: any) => [
                            <Popconfirm
                                key="delete"
                                title="是否删除此行数据？"
                                okText="确定"
                                cancelText="取消"
                                style={{ zIndex: 999 }}
                                onConfirm={() => {
                                    handleDeleteItem(record?.seqNumber);
                                }}
                            >
                                <Button type="link">删除</Button>
                            </Popconfirm>,
                        ],
                    },
                ]);
                setCurrent(1);
                setExportTableData(data.tableData);
            } catch (e) {
                message.warning('上传格式错误，请确认上传模板1！');
                return;
            }
        };
        return false;
    };
    // 上传配置
    const props: UploadProps = {
        name: 'dataImport',
        accept: '.xls, .xlsx',
        beforeUpload: beforeUpload,
    };
    // 操作模块样式
    const UploadItem = ({ icon, title, description, children }: any) => (
        <div className="uploadItem">
            <div className="itemLeft">
                <Icon type={icon} />
            </div>
            <div className="itemRight">
                <div className="title">{title}</div>
                <p className="dic">{description}</p>
                {children}
            </div>
        </div>
    );

    // 提示文案
    const AlertBox = () => (
        <div className="alertBox">
            <div className="icon">
                <Icon type="exclamation-circle" />
            </div>
            <div className="constnt">
                <div className="message">特别提示</div>
                <div className="description">导入过程中如发现已有相同数据，则更新这条数据。</div>
            </div>
        </div>
    );
    // 下载模板
    const DownList = () => (
        <div>
            <div
                className="downValue"
                onClick={() => {
                    services.api
                        .download(
                            {},
                            {
                                apiPath: `/templates/${templateDown}`,
                            }
                        )
                        .then((res: any) => {})
                        .catch((e: any) => {
                            errorHandle(e);
                        });
                }}
            >
                下载模板
            </div>
        </div>
    );
    return (
        <>
            <Steps current={current}>
                {steps.map((item) => (
                    <Step key={item.title} title={item.title} />
                ))}
            </Steps>
            <div className="steps-content">
                {current === 0 && (
                    <div className="step-one">
                        <Spin tip="数据识别中" spinning={showSpinning}>
                            <div className="content">
                                <UploadItem
                                    icon="download"
                                    title={
                                        <div className="modalboxTitle">
                                            填写导入数据信息
                                            <div className="modalboxTitleTip">
                                                （此模板中包含示例，请您不要删除）
                                            </div>
                                        </div>
                                    }
                                    description="请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除"
                                >
                                    <div className="fillIn">
                                        <DownList />
                                    </div>
                                </UploadItem>
                                <UploadItem
                                    icon="upload"
                                    title="上传填好的信息表"
                                    description={`文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于${limitSize ||
                                        10}M`}
                                >
                                    <div className="uploadBox">
                                        <Upload {...props}>
                                            <div className="downValue">上传文件</div>
                                        </Upload>
                                    </div>
                                </UploadItem>
                                <AlertBox />
                            </div>
                        </Spin>
                    </div>
                )}
                {current === 1 && exportTableData.length > 0 && (
                    <div className="step-two">
                        <List
                            dataSource={failList}
                            renderItem={(item) => (
                                <List.Item style={{ color: 'red' }}>
                                    第{item.lineCode}行: {item.msg}
                                </List.Item>
                            )}
                        />
                        <Table
                            rowKey="seqNumber"
                            columns={column}
                            dataSource={exportTableData}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showQuickJumper: true,
                                pageSizeOptions: ['10', '15', '20'],
                                showTotal(total: number) {
                                    return `共 ${total} 条记录`;
                                },
                            }}
                        ></Table>
                        <div style={{ textAlign: 'right', marginTop: 16 }}>
                            <Button
                                style={{ marginRight: 8 }}
                                type="primary"
                                onClick={() => {
                                    setCurrent(0);
                                }}
                            >
                                上一步
                            </Button>
                            <Button
                                style={{ marginRight: 8 }}
                                type="primary"
                                onClick={() => {
                                    saveData(exportTableData);
                                }}
                            >
                                确认
                            </Button>
                            <Button
                                onClick={() => {
                                    handleCancel();
                                }}
                            >
                                取消
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ExportExcel;
